const initialState = {
  isNewAssetType: false,
  type: null,
  id: '',
};

export default initialState;
